import { FC } from 'react';
import { IconProps } from './SatIcon';

const DashboardIcon: FC<IconProps> = ({ id, className, fill }) => {
  return (
    <svg
      id={id}
      width="32"
      className={className}
      height="32"
      viewBox="0 0 31 30"
      fill={fill || 'none'}
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.1851 0H28.5601C29.7663 0 30.7476 0.98125 30.7476 2.1875V7.8125C30.7476 9.01875 29.7663 10 28.5601 10H19.1851C17.9788 10 16.9976 9.01875 16.9976 7.8125V2.1875C16.9976 0.98125 17.9788 0 19.1851 0Z"
        fill={fill || '#89AAEC'}
      />
      <path
        d="M19.1851 12.5H28.5601C29.7663 12.5 30.7476 13.4813 30.7476 14.6875V27.8125C30.7476 29.0187 29.7663 30 28.5601 30H19.1851C17.9788 30 16.9976 29.0187 16.9976 27.8125V14.6875C16.9976 13.4813 17.9788 12.5 19.1851 12.5Z"
        fill={fill || '#89AAEC'}
      />
      <path
        d="M2.93506 20H12.3101C13.5163 20 14.4976 20.9813 14.4976 22.1875V27.8125C14.4976 29.0187 13.5163 30 12.3101 30H2.93506C1.72881 30 0.747557 29.0187 0.747557 27.8125V22.1875C0.747557 20.9813 1.72881 20 2.93506 20Z"
        fill={fill || '#89AAEC'}
      />
      <path
        d="M2.93506 0H12.3101C13.5163 0 14.4976 0.98125 14.4976 2.1875V15.3125C14.4976 16.5187 13.5163 17.5 12.3101 17.5H2.93506C1.72881 17.5 0.747557 16.5187 0.747557 15.3125V2.1875C0.747557 0.98125 1.72881 0 2.93506 0Z"
        fill={fill || '#89AAEC'}
      />
    </svg>
  );
};

export default DashboardIcon;
